import { useExperimentTreatmentWithoutReporting } from '../experiments';

type UseIsM365CopilotAdoptionEnabled = () => boolean;
export const useIsM365CopilotAdoptionEnabled: UseIsM365CopilotAdoptionEnabled = () =>
  useExperimentTreatmentWithoutReporting('M365CopilotAdoption') === true;
